import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useI18nStore } from '@/app/modules/i18n';
import { useLatestCall } from '@/app/composables';
import { StoreNames } from '@/app/shared/store-names';
import { useSupersetApi } from '../services';

type Keys = Record<
  string,
  {
    text: string;
    description: string;
  }
>;

export const useSupersetKeyMetaStore = defineStore(StoreNames.SupersetKeyMeta, () => {
  const keys = ref<Keys>({});
  const { bffGetKeys } = useSupersetApi();

  const { call: fetch, processing: fetching } = useLatestCall(
    async (signal) => {
      const i18nStore = useI18nStore();
      return bffGetKeys(i18nStore.locale, { signal });
    },
    {
      onSuccess: (data) => {
        keys.value = data.reduce<Keys>((acc, item) => {
          acc[item.key] = {
            text: item.translations[0]?.text,
            description: item.translations[0]?.description,
          };

          return acc;
        }, {});
      },
    },
  );

  function clear() {
    keys.value = {};
  }

  return {
    fetch,
    fetching,
    clear,
    keys,
  };
});
